import { render, staticRenderFns } from "./CheckBalance.vue?vue&type=template&id=2aab846a&scoped=true&"
import script from "./CheckBalance.vue?vue&type=script&lang=ts&"
export * from "./CheckBalance.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBalance.vue?vue&type=style&index=0&id=2aab846a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aab846a",
  null
  
)

export default component.exports